import axios from "axios";
import { clearAuthToken, getAuthToken } from "./authSession";

const apiUrl =
  process.env.REACT_APP_API_URL?.trim() || "https://sae.aclsconnect.com/api";
const socketUrl =
  process.env.REACT_APP_SOCKET_URL?.trim() || "https://sae.aclsconnect.com";
const configuredTimeout = Number(process.env.REACT_APP_API_TIMEOUT_MS);

export const apiSae = axios.create({
  baseURL: apiUrl,
  timeout:
    Number.isFinite(configuredTimeout) && configuredTimeout > 0
      ? configuredTimeout
      : 10000,
});

apiSae.interceptors.response.use(
  (response) => response,
  (error) => {
    const token = getAuthToken();
    if (error.response?.status === 401 && token &&
        error.config?.headers?.Authorization === `Bearer ${token}`) {
      clearAuthToken();
    }
    return Promise.reject(error);
  }
);

export const urlWebSockt = socketUrl;
export const socketPath =
  process.env.REACT_APP_SOCKET_PATH?.trim() || "/67ZlfPVt/socket.io";
